// This file contains specific intervention activities for developmental delays.
// These are suggested actions when an assessment result is 'Meragukan'.

export const interventionPlans = {
    perkembangan: { // Corresponds to KPSP
        title: "Rencana Intervensi Perkembangan",
        description: "Lakukan aktivitas berikut secara rutin selama 2 minggu ke depan untuk menstimulasi area yang teridentifikasi 'Meragukan'. Lakukan pemeriksaan KPSP ulang setelahnya.",
        activities: [
            { id: "int_motor_kasar_1", text: "Latih berjalan di berbagai permukaan (rumput, lantai, karpet) sambil berpegangan." },
            { id: "int_motor_halus_1", text: "Ajak anak meremas adonan mainan (play-doh) atau kertas untuk menguatkan jari." },
            { id: "int_bahasa_1", text: "Bacakan buku cerita dengan gambar menarik setiap hari, tunjuk dan sebutkan nama gambar." },
            { id: "int_sosial_1", text: "Ajak anak bermain bersama teman sebaya dan ajarkan konsep 'bergiliran'." },
            { id: "int_motor_halus_2", text: "Latih anak memasukkan balok kecil ke dalam wadah atau botol." }
        ]
    },
    // Future intervention plans for other areas can be added here.
    mental: {
        title: "Rencana Intervensi Mental Emosional",
        description: "Aktivitas berikut dapat membantu menenangkan dan membangun ikatan emosional dengan anak. Jika tidak ada perbaikan, segera konsultasi dengan ahli.",
        activities: [
            { id: "int_emosi_1", text: "Ciptakan rutinitas harian yang konsisten dan dapat diprediksi oleh anak." },
            { id: "int_emosi_2", text: "Berikan pelukan dan sentuhan fisik yang menenangkan saat anak tampak cemas atau marah." },
            { id: "int_emosi_3", text: "Validasi perasaan anak dengan berkata, 'Bunda tahu kamu marah/sedih, tidak apa-apa'." },
        ]
    }
};
